module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-swipe', {
    staticClass: "m-swipe",
    attrs: {
      "auto": 0,
      "defaultIndex": _vm.data.activeIndex,
      "continuous": false
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hide($event)
      }
    }
  }, _vm._l((_vm.data.imgs), function(item) {
    return _c('mt-swipe-item', {
      key: "item.id"
    }, [_c('img', {
      attrs: {
        "src": _vm.filter(item.src)
      },
      on: {
        "mousewheel": function($event) {
          $event.preventDefault();
        },
        "DOMMouseScroll": function($event) {
          $event.preventDefault();
        }
      }
    })])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f915308a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/swipe/swipe.vue
// module id = 218
// module chunks = 1